<script>
import { mapState, mapGetters } from 'vuex'
import CredentialDetail from '@/components/identity/CredentialDetail'
import HiveConnection from '@/components/hives/HiveConnection'
import moment from 'moment'

export default {
  components: {
    CredentialDetail,
    HiveConnection
  },
  props: {},
  data() {
    return {
      name: '',
      description: '',
      identityName: '',
      // identityValidity: '',
      selectedIdentityType: {},
      selectedHiveType: {},
      selectedConnectionType: {},
      validity: Date.now(),
      credential: [],
      connection: [],
      hiveCreated: false
    }
  },

  methods: {
    async create() {
      if (this.name !== '' && this.description !== '') {
        let credentials = {}
        this.identityStructure.forEach(element => {
          if (element.key === this.selectedIdentityType.key) {
            let credential = {}
            this.credential.forEach(option => {
              if (option.options) {
                credential[option.fieldName] = option.value.key
              } else {
                credential[option.fieldName] = option.value
              }
            })
            credentials[element.fieldName] = credential
          } else {
            credentials[element.fieldName] = null
          }
        })

        let connections = {}
        this.getHiveConnectionStructures.forEach(element => {
          if (element.key === this.selectedConnectionType.key) {
            let connection = {}
            this.connection.forEach(option => {
              if (option.options) {
                connection[option.fieldName] = option.value.key
              } else {
                connection[option.fieldName] = option.value
              }
            })
            connections[element.fieldName] = connection
          } else {
            connections[element.fieldName] = null
          }
        })
        this.hiveCreated = true
        try {
          let hive = await this.$store.dispatch('saveHive', {
            name: this.name,
            description: this.description,
            hiveType: this.selectedHiveType.key,
            hiveConnectionType: this.selectedConnectionType.key,
            hiveConnection: connections,
            identityType: this.selectedIdentityType.key,
            credential: credentials,
            active: true
          })
          await this.$store.dispatch('directNotification', {
            type: 'success',
            message: 'Agent added Successfully',
            description:
              'The Agent has been added with name ' +
              hive.name +
              ' , Id ' +
              hive.hexId,
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
          this.$store.dispatch('fetchHives')
          this.$router.replace({ name: 'hive-list' }).catch()
          this.hiveCreated = false
        } catch (e) {
          await this.$store.dispatch('directNotification', {
            type: 'error',
            message: 'Unable to add Agent',
            description: e.response
              ? e.response.data.message
              : 'Error unknown! Kindly retry',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
          this.hiveCreated = false
        }
      } else {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Enter the missing fields',
          description: 'Enter the missing fields',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
    },
    backToList() {
      this.$router.replace({ name: 'hive-list' }).catch()
    },
    credentialUpdated(credential) {
      this.credential = credential
    },
    connectionsUpdated(connection) {
      this.connection = connection
    }
  },

  created: function() {
    this.$store.dispatch('fetchIdentityStructure')
    this.$store.dispatch('fetchIdentityTypes')
    this.$store.dispatch('fetchHiveConnectionTypes')
    this.$store.dispatch('fetchHiveConnectionStructures')
  },

  computed: {
    ...mapState({
      identityTypes: state => state.enums.identityTypes,
      hiveTypes: state => state.enums.hiveTypes,
      identityStructure: state => state.identities.identityStructure,
      hiveConnectionTypes: state => state.enums.hiveConnectionTypes
    }),
    ...mapGetters(['getHiveConnectionStructures']),

    selectedIdentityTypes() {
      let _self = this
      let selectedIdentityTypes = _self.identityTypes.filter(element => {
        if (_self.selectedConnectionType.key === 'SAP_ODATA') {
          return element.key === 'BASIC_AUTH'
        } else if (_self.selectedConnectionType.key === 'SAP_RFC_CUSTOM') {
          return element.key === 'SAP_AUTH'
        } else if (_self.selectedConnectionType.key === 'SAP_RFC_GROUP') {
          return element.key === 'SAP_AUTH'
        }
      })
      if (selectedIdentityTypes) {
        return selectedIdentityTypes
      } else {
        return []
      }
    },

    selectedIdentityStructureOptions() {
      let selectedIdentityStructure = this.identityStructure.find(element => {
        return element.key === this.selectedIdentityType.key
      })
      if (selectedIdentityStructure) {
        return selectedIdentityStructure.options
      } else {
        return []
      }
    },
    selectedHiveConnectionTypes() {
      this.selectedIdentityType = {}
      this.selectedConnectionType = {}
      let selectedHiveConnectionTypes = this.hiveConnectionTypes.filter(
        element => {
          if (this.selectedHiveType.key === 'SAP') {
            return ['SAP_ODATA', 'SAP_RFC_CUSTOM', 'SAP_RFC_GROUP'].includes(
              element.key
            )
          } else {
            return [
              'IP_PORT',
              'IP6_PORT',
              'HOST_NAME_PORT',
              'HOST_NAME'
            ].includes(element.key)
          }
        }
      )
      if (selectedHiveConnectionTypes) {
        return selectedHiveConnectionTypes
      } else {
        return []
      }
    },

    selectedHiveConnectionStructureOptions() {
      this.selectedIdentityType = {}
      let selectedHiveStructure = this.getHiveConnectionStructures.find(
        element => {
          return element.key === this.selectedConnectionType.key
        }
      )
      if (selectedHiveStructure) {
        return selectedHiveStructure.options
      } else {
        return []
      }
    }
  }
}
</script>

<template>
  <v-card>
    <v-toolbar dense card class="elevation-2">
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="backToList">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <span>Back</span>
      </v-tooltip>
      <v-toolbar-title class="body-2 "
        >Create new Automation Agent
      </v-toolbar-title>
      <!-- Actions icon list goes here -->
    </v-toolbar>
    <!-- Actions icon list goes here -->

    <v-layout row wrap pa-4>
      <v-flex xs12 sm3>
        <v-subheader v-text="'Agent Name'" />
      </v-flex>
      <v-flex xs12 sm9>
        <v-text-field
          label="Agent Name"
          color="secondary"
          hint="Enter a name for the Agent"
          persistent-hint
          v-model="name"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 sm3>
        <v-subheader v-text="'Agent Description'" />
      </v-flex>
      <v-flex xs12 sm9>
        <v-text-field
          label="Agent Description"
          color="secondary"
          hint="Agent Description"
          v-model="description"
        />
      </v-flex>

      <v-flex xs12 sm3 mt-4>
        <v-subheader v-text="'Agent Type'" />
      </v-flex>
      <v-flex xs12 sm9 mt-4>
        <v-select
          item-text="friendlyName"
          item-value="key"
          color="secondary"
          :items="hiveTypes"
          v-model="selectedHiveType"
          label="Agent Type"
          return-object
        >
        </v-select>
      </v-flex>

      <v-flex xs12 sm3 mt-4>
        <v-subheader v-text="'Agent Connection Type'"></v-subheader>
      </v-flex>
      <v-flex xs12 sm9 mt-4>
        <v-select
          item-text="friendlyName"
          item-value="key"
          color="secondary"
          :items="selectedHiveConnectionTypes"
          v-model="selectedConnectionType"
          label="Connection Type"
          return-object
        >
        </v-select>
      </v-flex>
      <v-flex xs12 v-if="selectedConnectionType">
        <v-layout row wrap>
          <v-flex xs12 sm3 mt-4>
            <v-subheader v-text="'Agent Connection Params'"></v-subheader>
          </v-flex>
          <v-flex xs12 sm9 mt-4>
            <hive-connection
              :value="selectedHiveConnectionStructureOptions"
              @input="connectionsUpdated"
            ></hive-connection>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 v-if="selectedIdentityTypes.length > 0">
        <v-layout row wrap>
          <v-flex xs12 sm3 mt-4>
            <v-subheader v-text="'Identity Type'"></v-subheader>
          </v-flex>
          <v-flex xs12 sm9 mt-4>
            <v-select
              item-text="friendlyName"
              item-value="key"
              :items="selectedIdentityTypes"
              v-model="selectedIdentityType"
              label="Identity Type"
              return-object
            >
            </v-select>
          </v-flex>
          <v-flex xs12 sm3 mt-4 v-if="selectedIdentityType">
            <v-subheader>Authorization Params</v-subheader>
          </v-flex>
          <v-flex xs12 sm9 mt-4 v-if="selectedIdentityType">
            <credential-detail
              :value="selectedIdentityStructureOptions"
              @input="credentialUpdated"
            ></credential-detail>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-card-actions>
      <v-layout justify-center>
        <v-btn
          :class="
            $vuetify.dark
              ? 'secondary text-capitalize'
              : 'primary text-capitalize'
          "
          :outline="$vuetify.dark"
          @click="create"
          large
          class="text-capitalize"
          :loading="hiveCreated"
          >Create Agent
        </v-btn>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>
